<template>
	<Spin v-if="innerLoading" fix>
		<Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
		<div>{{ $t('global.loading') }}</div>
	</Spin>
	<div v-else class="d-flex flex-column">
		<div>
			<div v-if="groupStageFinished">
				<hr class="mt-4 mb-4" />

				<h2 class="mb-4">Playoff</h2>

				<div v-if="spec === 'single' && (qty.toString() === '2' || qty.toString() === '3')">
					<Single2Groups />
				</div>

				<div v-else-if="spec === 'wildcard' && qty.toString() === '2'">
					<Wildcard2Groups />
				</div>

				<div v-else-if="spec === 'single' && qty.toString() === '4'">
					<Single4Groups />
				</div>

				<div v-else-if="spec === 'wildcard' && qty.toString() === '4'">
					<Wildcard4Groups />
				</div>

				<div v-else-if="spec === 'stepladder' && qty.toString() === '2'" class="mt-2">
					<Stepladder />
				</div>

				<div v-else>
					<h1 class="mt-4 text-danger">Данный формат/количество групп не поддерживает текущее количество команд.</h1>
				</div>
			</div>
		</div>

		<MatchCircuitModal v-if="circuitModal" :modal="circuitModal" :match="selectedMatch" :competition="competition"
			@close="(e) => close(e)" @getCurrentTeams="getCurrentTeams" />
	</div>
</template>

<script>
import MatchCircuitModal from './MatchCircuitModal.vue';
import draggable from 'vuedraggable';
import PlayoffStageFour from '../../utils/PlayoffStageFour.vue';
import Stepladder from './groups/Stepladder.vue';
import Single2Groups from './groups/Single2Groups.vue';
import Single4Groups from './groups/Single4Groups.vue';
import Wildcard2Groups from './groups/Wildcard2Groups.vue';
import Wildcard4Groups from './groups/Wildcard4Groups.vue';
import store from './storeMixin';
export default {
	name: 'Group',
	components: { MatchCircuitModal, draggable, Stepladder, Single2Groups, Single4Groups, Wildcard2Groups, Wildcard4Groups },
	data() {
		return store;
	},
	async created() {
		this.innerLoading = true;
		this.isCurrentStage = Boolean(this.competition.stages.find(({ isCurrent }) => isCurrent));
		this.saveRounds(this.competition.stages.find(({ isCurrent }) => isCurrent).rounds);
		await this.getCurrentTeams();
		// if (this.ladder.length)
		//   console.log(this.ladder);
		// this.getCurrentCompetition(true)
		if (this.spec === 'single') await this.getPlayoffMatches('single');
		else if (this.spec === 'ladder') await this.getPlayoffMatches('ladder');
		else if (this.spec === 'wildcard') await this.getPlayoffMatches('wildcard');

		if (this.single.length && this.single.every((match) => match.isFinished) && !this.showFinalStandings) {
			if (
				this.single.length !==
				this.getSEMatchQty(this.single.filter(({ playoffStage }) => playoffStage === 1).length) +
				this.getSEMatchQty(this.single.filter(({ playoffStage }) => playoffStage === -1).length)
			) {
				await this.singlePlayoffMatches();
				// window.location.reload();
			} else {
				this.getFinalStandings('single');
				this.showFinalStandings = true;
			}
		} else if (this.wildcard.length && this.wildcard.every((match) => match.isFinished)) {
			if (
				this.wildcard.length !==
				this.getWCMatchQty(this.wildcard.filter(({ playoffStage }) => playoffStage === 1).length) +
				this.getWCMatchQty(this.wildcard.filter(({ playoffStage }) => playoffStage === -1).length)
			) {
				await this.wildCardPlayoffMatches();
				window.location.reload();
			} else {
				this.getFinalStandings('wildcard');
				this.showFinalStandings = true;
			}
		} else if (this.ladder.length && this.ladder.every((match) => match.isFinished)) {
			if (this.ladder.length !== this.teams.length / 2) {
				await this.ladderPlayoffMatches();
				// window.location.reload();
			} else {
				this.getFinalStandings('ladder');
				this.showFinalStandings = true;
			}
		}
		this.innerLoading = false;
	},
};
</script>

<style>
.table-card-style {
	height: 100%;
	box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.table-card-style:hover {
	box-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}

/* .match-table {
		width: 100%;
	} */
.table-margin {
	margin: 10px 0px;
}

.table-margin-middle {
	margin: 96px 0px;
}

.table-margin-large {
	margin: 216px 0px 0px;
}

.bracket-connector {
	height: 2px;
}

.w-60px {
	width: 60px;
	height: 36px;
}

.w-70px {
	width: 70px;
	height: 36px;
}

.cursor {
	cursor: pointer;
}

.w-300px {
	width: 300px;
	height: 36px;
}

/* .match-table th,
	.match-table td {
		padding: 0.6rem 0 0.6rem 0.75rem;
		border: 1px solid #eff2f7;
	}

  .match-table th {
    padding-right: 0.75rem;
  } */

.match-table.table-bordered tr td,
.match-table.table-bordered tr th {
	border-width: 1px !important;
}

.match-table.table-bordered td {
	border: none !important;
}

.tournament-stage .match-table td:hover {
	background: transparent !important;
}

.match-table td:hover {
	background: #e4e4e4;
}

.second-line {
	margin: 260px 0 0px 0;
}

.min-w-400px {
	min-width: 400px;
}

.icon-pos {
	position: absolute;
	bottom: -0.5rem;
	left: -0.5rem;
	color: #2d8cf0;
	z-index: 10;
	font-size: 20px;
	background: white;
	border-radius: 50%;
	width: 16px;
	height: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.inline-table {
	display: inline-table;
}

.icon-pos:hover {
	transform: scale(1.15);
}

.first-table-row th {
	background: var(--bg-darkness);
	color: var(--text-color);
	border-color: var(--bg-darkness);
}

.first-table-row th h3 {
	color: var(--text-color);
}

.text-overflow-style {
	padding: 0 0.75rem 0 0;
	white-space: nowrap;
	overflow: hidden;
	display: inline-block;
	text-overflow: ellipsis;
}

.text-size-clamp {
	font-size: clamp(0.6rem, 1vw, 1rem);
	text-wrap: balance !important;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/Group.vue